/**
 * Company actions
 *
 */
export const GET_ACTIVE_SINGLE_COMPANY = 'GET_ACTIVE_SINGLE_COMPANY';
export const SET_ACTIVE_SINGLE_COMPANY = 'SET_ACTIVE_SINGLE_COMPANY';
export const GET_COMPANY_BY_COUNTRY = 'GET_COMPANY_BY_COUNTRY';
